export default __webpack_public_path__ + "static/media/006-pompom-green.7352dacd.svg";